import { RigidBodyConstructionInfo } from "../rigidBodyConstructionInfo";
export class PluginConstructionInfo extends RigidBodyConstructionInfo {
    worldId;
    commandsOnCreation;
    constructor(wasmInstance) {
        super(wasmInstance);
        this.worldId = 0;
        this.commandsOnCreation = [];
    }
}
